import React, { useState } from "react";
import ProductListingHeader from "./ProductListingHeader";

function ProductListingAPIMainComponent() {
    const [activeTab, setActiveTab] = useState("store");
    const [listingData, setListingData] = useState({});
    const steps = [
        "store", "product", "category", "attributes", "images",
        "variations", "pricing", "inventory", "review", "publish"
    ];

    const handleNext = (data = {}) => {

        setListingData(prev => ({
            ...prev,
            ...data
        }));

        const currentIndex = steps.indexOf(activeTab);

        if (currentIndex < steps.length - 1)
            setActiveTab(steps[currentIndex + 1]);
    };

    const handleBack = () => {
        const currentIndex = steps.indexOf(activeTab);
        if (currentIndex > 0) setActiveTab(steps[currentIndex - 1]);
    };

    return (
        <div className="mt-5 pt-3 container-fluid">
            <ProductListingHeader
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                handleNext={handleNext}
                handleBack={handleBack}
                listingData={listingData}
            />
        </div>
    );
}

export default ProductListingAPIMainComponent;